<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">
        
        <h2>Acknowledgements</h2>

        Many people have contributed in various ways to this project!  Every successful work on weaving involves the efforts of others and
        many thanks are due to those who have helped with Handweaving.net and Ralph Griswold's Archive!<br><br>
        
        <b-row>
            <b-col>
                <ul>
                    <li>Alice Schlein</li>
                    <li>Anita Bell</li>
                    <li>Anne Wells</li>
                    <li>Arahne CAD/CAM Systems</li>
                    <li>Aurelia Loveman</li>
                    <li>Bentley Library of the University of Michigan</li>
                    <li>Bernadine Goodrich</li>
                    <li>Betty Lou Whaley</li>
                    <li>Bishop Library of Lebanon Valley College, PA</li>
                    <li>Bojana Ažman</li>
                    <li>Bonnie Inouye</li>
                    <li>Brian Lemin</li>
                    <li>Company of St. Catherine Spinning &amp; Weaving Guild</li>
                    <li>Dawn Talbot</li>
                    <li>Deb Schillo</li>
                    <li>Debra Losey</li>
                    <li>Despina Koutsika</li>
                    <li>Devon Thein</li>
                    <li>Diana Smith</li>
                    <li>Drury University, F. W. Olin Library</li>
                    <li>Elaine O'Donal</li>
                    <li>Elizabeth Moncrief</li>
                    <li>Elizabeth (Bettes) Silver-Schack</li>
                    <li>Eva Basile</li>
                    <li>Falmouth Memorial Library, Falmouth Maine</li>
                    <li>Free Library of Philadelphia</li>
                    <li>Gina Ziegler</li>
                    <li>Gunnel Teitel</li>
                    <li>Harmony Weavers Guild</li>
                    <li>Helen Kiker</li>
                    <li>Holli Seery</li>
                    <li>Janet Stollnitz</li>
                    <li>Janis Cohen</li>
                    <li>Jean-Paul Leclerq</li>
                    <li>Jean Leader</li>
                    <li>Jeri Ames</li>
                    <li>Jill Saman</li>
                    <li>Joan McTeer</li>
                    <li>Josette Martin</li>
                    <li>Judie Eatough</li>
                    <li>Karen Jania</li>
                    <li>Karen Madigan</li>
                    <li>Karen Searles</li>
                    <li>Karen Thompson</li>
                    <li>Kris Bruland</li>
                    <li>Kristin Bergstad</li>
                    <li>Laurie Autio</li>
                    <li>Lena Dalren</li>
                    <li>Lenoard Bazar</li>
                    <li>Linda Hendrickson</li>
                    <li>Linda Lindsey</li>
                    <li>Linda Liontos</li>
                    <li>Logos Bible Software</li>
                    <li>Loretta Melnychuk</li>
                    <li>Lori Howe</li>
                    <li>Loški muzej v Sloveniji</li>
                    <li>Madelyn van der Hoogt</li>
                    <li>Margaret Coe</li>
                    <li>Marji Suhm</li>
                    <li>Marjie Thompson</li>
                    <li>Maryann Ariizumi</li>
                    <li>Nancy M. McKenna</li>
                    <li>Nancy Mellinger Plack</li>
                    <li>Nancy Spies</li>
                    <li>Patricia Stewart</li>
                    <li>Patty Bruland</li>
                    <li>Patty Dowden</li>
                    <li>Peter Collingwood</li>
                    <li>Philippe Demoule</li>
                    <li>Portland Public Library, Portland Maine</li>
                    <li>Ralph Griswold</li>
                    <li>Renee van Walsum</li>
                    <li>Rocky Mountain Lace Guild Library</li>
                    <li>Rosa Blanca Bellemo</li>
                    <li>Roxie Rochat</li>
                    <li>Ruth Blau</li>
                    <li>Saša Nabergoj</li>
                    <li>Sharon Bowles</li>
                    <li>Sora Sagano</li>
                    <li>Stan Furmanak</li>
                    <li>Su Butler</li>
                    <li>Tess Parrish</li>
                    <li>The Southern Highland Craft Guild</li>
                    <li>University of Arizona Special Collections Staff</li>
                    <li>University of Arizona Dept. of Computer Science</li>
                    <li>Ute Bargmann</li>
                    <li>Vibeke Ervo</li>
                    <li>Washington (Pennsylvania) Spinners and Weavers</li>
                    <li>Whidbey Weavers Guild (WWG)</li>
                    <li>XRX, Inc.</li>
                </ul>
            </b-col>
            <b-col>
                <img style='max-width: 100%' class='right-padding bottom-padding left-padding' :src='this.getSiteImageUrl("ephemera-postcard-000273-5.jpg")' />
            </b-col>
        </b-row>

        <helpUsButton/>
        <mailChimpSignup/>
    </b-container>
</template>

<script>
import mailChimpSignup from './MailChimpSignup.vue'
import helpUsButton from './HelpUsButton.vue'
import mediaService from '../mixins/mediaService.js'
export default {
    mixins: [mediaService],
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup
    },
    created() {
        this.$store.commit('setPageTitle', 'Acknowledgements')
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Acknowledgements.vue